// Labirin Huruf Ajaib - Maze Game Data & Helpers

import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
export const CHARACTERS = [
  { id: "boy", emoji: "\uD83D\uDC66", name: "Anak Laki-laki", color: "#45B7D1" },
  { id: "girl", emoji: "\uD83D\uDC67", name: "Anak Perempuan", color: "#FF69B4" },
  { id: "rabbit", emoji: "\uD83D\uDC30", name: "Kelinci Lucu", color: "#FFB347" },
];

// Maze templates: 0=path, 1=wall
// 9 columns x 7 rows - simple kid-friendly layouts
export const MAZE_TEMPLATES = [
  { // Template 0: Very open
    grid: [
      [1,1,1,1,1,1,1,1,1],
      [1,0,0,0,0,0,0,0,1],
      [1,0,1,0,1,0,1,0,1],
      [1,0,0,0,0,0,0,0,1],
      [1,0,1,0,1,0,1,0,1],
      [1,0,0,0,0,0,0,0,1],
      [1,1,1,1,1,1,1,1,1],
    ],
    start: [3,4],
    answers: [[1,1],[1,7],[5,1],[5,7]],
  },
  { // Template 1: Cross corridors
    grid: [
      [1,1,1,1,1,1,1,1,1],
      [1,0,0,0,1,0,0,0,1],
      [1,0,1,0,0,0,1,0,1],
      [1,0,0,0,1,0,0,0,1],
      [1,0,1,0,0,0,1,0,1],
      [1,0,0,0,1,0,0,0,1],
      [1,1,1,1,1,1,1,1,1],
    ],
    start: [3,2],
    answers: [[1,1],[1,7],[5,1],[5,7]],
  },
  { // Template 2: S-curve
    grid: [
      [1,1,1,1,1,1,1,1,1],
      [1,0,0,0,0,0,1,0,1],
      [1,1,1,1,1,0,0,0,1],
      [1,0,0,0,0,0,1,1,1],
      [1,0,1,1,1,0,0,0,1],
      [1,0,0,0,0,0,1,0,1],
      [1,1,1,1,1,1,1,1,1],
    ],
    start: [1,1],
    answers: [[1,4],[3,1],[5,3],[5,7]],
  },
  { // Template 3: Rooms
    grid: [
      [1,1,1,1,1,1,1,1,1],
      [1,0,0,1,0,0,0,0,1],
      [1,0,0,0,0,1,1,0,1],
      [1,1,0,1,0,0,0,0,1],
      [1,0,0,0,0,1,0,1,1],
      [1,0,1,0,0,0,0,0,1],
      [1,1,1,1,1,1,1,1,1],
    ],
    start: [1,1],
    answers: [[1,5],[3,5],[5,1],[5,5]],
  },
  { // Template 4: Spiral-ish
    grid: [
      [1,1,1,1,1,1,1,1,1],
      [1,0,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,1,0,1],
      [1,0,1,0,0,0,0,0,1],
      [1,0,1,0,1,1,1,1,1],
      [1,0,0,0,0,0,0,0,1],
      [1,1,1,1,1,1,1,1,1],
    ],
    start: [1,1],
    answers: [[1,7],[3,5],[5,5],[5,1]],
  },
];

export const LEVELS = [
  {
    id: 1,
    name: "Cari Huruf",
    icon: "\uD83D\uDD24",
    color: "#FF6B6B",
    world: "Hutan Huruf",
    questions: [
      { q: "Cari huruf A", correct: "A", options: ["A", "B", "C", "D"] },
      { q: "Cari huruf M", correct: "M", options: ["M", "K", "N", "W"] },
      { q: "Cari huruf S", correct: "S", options: ["S", "Z", "C", "X"] },
    ]
  },
  {
    id: 2,
    name: "Cari Angka",
    icon: "\uD83D\uDD22",
    color: "#4ECDC4",
    world: "Gua Angka",
    questions: [
      { q: "Pilih angka 5", correct: "5", options: ["5", "3", "8", "2"] },
      { q: "Pilih angka 9", correct: "9", options: ["6", "9", "4", "1"] },
      { q: "Pilih angka 7", correct: "7", options: ["1", "4", "7", "2"] },
    ]
  },
  {
    id: 3,
    name: "Cari Warna",
    icon: "\uD83C\uDFA8",
    color: "#FF69B4",
    world: "Taman Warna",
    questions: [
      { q: "Temukan warna Merah", correct: "\uD83D\uDD34", options: ["\uD83D\uDD34", "\uD83D\uDD35", "\uD83D\uDFE2", "\uD83D\uDFE1"] },
      { q: "Temukan warna Biru", correct: "\uD83D\uDD35", options: ["\uD83D\uDFE0", "\uD83D\uDD35", "\uD83D\uDFE3", "\uD83D\uDFE2"] },
      { q: "Temukan warna Kuning", correct: "\uD83D\uDFE1", options: ["\uD83D\uDD34", "\uD83D\uDFE2", "\uD83D\uDFE1", "\uD83D\uDFE3"] },
    ]
  },
  {
    id: 4,
    name: "Nama Hewan",
    icon: "\uD83D\uDC3E",
    color: "#FFB347",
    world: "Kebun Binatang",
    questions: [
      { q: "Cari gambar Kucing", correct: "\uD83D\uDC31", options: ["\uD83D\uDC36", "\uD83D\uDC31", "\uD83D\uDC30", "\uD83D\uDC26"] },
      { q: "Cari gambar Gajah", correct: "\uD83D\uDC18", options: ["\uD83D\uDC18", "\uD83E\uDD81", "\uD83D\uDC2F", "\uD83D\uDC22"] },
      { q: "Cari gambar Kelinci", correct: "\uD83D\uDC30", options: ["\uD83D\uDC1F", "\uD83D\uDC26", "\uD83D\uDC30", "\uD83D\uDC36"] },
    ]
  },
  {
    id: 5,
    name: "Ejaan Kata",
    icon: "\u270D\uFE0F",
    color: "#9B59B6",
    world: "Istana Kata",
    type: "spelling",
    questions: [
      { q: "Susun kata: BOLA", letters: ["B", "O", "L", "A"] },
      { q: "Susun kata: IKAN", letters: ["I", "K", "A", "N"] },
      { q: "Susun kata: BUKU", letters: ["B", "U", "K", "U"] },
    ]
  },
  {
    id: 6,
    name: "Hitung Cepat",
    icon: "\u2795",
    color: "#E67E22",
    world: "Menara Hitung",
    questions: [
      { q: "2 + 3 = ?", correct: "5", options: ["4", "5", "6", "3"] },
      { q: "4 + 1 = ?", correct: "5", options: ["5", "3", "6", "7"] },
      { q: "6 - 2 = ?", correct: "4", options: ["3", "5", "4", "2"] },
    ]
  },
  {
    id: 7,
    name: "Buah Manis",
    icon: "\uD83C\uDF4E",
    color: "#16A34A",
    world: "Kebun Buah",
    questions: [
      { q: "Cari Apel", correct: "\uD83C\uDF4E", options: ["\uD83C\uDF4E", "\uD83C\uDF4C", "\uD83C\uDF47", "\uD83C\uDF53"] },
      { q: "Cari Pisang", correct: "\uD83C\uDF4C", options: ["\uD83C\uDF4A", "\uD83C\uDF4C", "\uD83C\uDF49", "\uD83C\uDF4D"] },
      { q: "Cari Jeruk", correct: "\uD83C\uDF4A", options: ["\uD83C\uDF50", "\uD83C\uDF52", "\uD83C\uDF4A", "\uD83C\uDF51"] },
      { q: "Cari Semangka", correct: "\uD83C\uDF49", options: ["\uD83C\uDF49", "\uD83C\uDF4D", "\uD83C\uDF53", "\uD83C\uDF47"] },
    ]
  },
  {
    id: 8,
    name: "Alat Transportasi",
    icon: "\uD83D\uDE97",
    color: "#0EA5E9",
    world: "Kota Sibuk",
    questions: [
      { q: "Cari Mobil", correct: "\uD83D\uDE97", options: ["\uD83D\uDE97", "\uD83D\uDE82", "\u2708\uFE0F", "\uD83D\uDEB2"] },
      { q: "Cari Kapal", correct: "\u26F5", options: ["\u2708\uFE0F", "\uD83D\uDE97", "\u26F5", "\uD83D\uDE82"] },
      { q: "Cari Pesawat", correct: "\u2708\uFE0F", options: ["\uD83D\uDE82", "\u2708\uFE0F", "\u26F5", "\uD83D\uDEB2"] },
      { q: "Cari Sepeda", correct: "\uD83D\uDEB2", options: ["\uD83D\uDEB2", "\uD83D\uDE97", "\uD83D\uDE82", "\u26F5"] },
    ]
  },
  {
    id: 9,
    name: "Anggota Tubuh",
    icon: "\uD83D\uDC42",
    color: "#EC4899",
    world: "Dunia Tubuh",
    questions: [
      { q: "Cari Mata", correct: "\uD83D\uDC41\uFE0F", options: ["\uD83D\uDC41\uFE0F", "\uD83D\uDC42", "\uD83D\uDC44", "\uD83D\uDC43"] },
      { q: "Cari Telinga", correct: "\uD83D\uDC42", options: ["\uD83D\uDC41\uFE0F", "\uD83D\uDC42", "\uD83D\uDC44", "\uD83D\uDC43"] },
      { q: "Cari Mulut", correct: "\uD83D\uDC44", options: ["\uD83D\uDC41\uFE0F", "\uD83D\uDC42", "\uD83D\uDC44", "\uD83D\uDC43"] },
      { q: "Cari Tangan", correct: "\u270B", options: ["\u270B", "\uD83D\uDC63", "\uD83D\uDC42", "\uD83D\uDC41\uFE0F"] },
    ]
  },
  {
    id: 10,
    name: "Master Labirin",
    icon: "\uD83C\uDFC6",
    color: "#DC2626",
    world: "Istana Akhir",
    questions: [
      { q: "Cari huruf Z", correct: "Z", options: ["Z", "S", "N", "M"] },
      { q: "Pilih angka 100", correct: "100", options: ["10", "100", "1000", "50"] },
      { q: "8 + 7 = ?", correct: "15", options: ["13", "14", "15", "16"] },
      { q: "Cari Bintang", correct: "\u2B50", options: ["\u2B50", "\u2728", "\u2764\uFE0F", "\uD83D\uDD37"] },
      { q: "Susun: PINTU", letters: ["P", "I", "N", "T", "U"] },
    ]
  },
];

// Shuffle array
export const shuffleArray = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Get maze for a level/question
export const getMazeForQuestion = (levelIndex, questionIndex) => {
  const templateIdx = (levelIndex + questionIndex) % MAZE_TEMPLATES.length;
  const template = MAZE_TEMPLATES[templateIdx];
  return {
    grid: template.grid.map(row => [...row]),
    start: [...template.start],
    answers: template.answers.map(a => [...a]),
  };
};

// Sound effects via Web Audio API
const audioCtx = typeof window !== 'undefined' ? new (window.AudioContext || window.webkitAudioContext)() : null;

const playTone = (freq, dur, type = 'sine', vol = 0.25) => {
  if (!audioCtx) return;
  try {
    if (audioCtx.state === 'suspended') audioCtx.resume();
    const o = audioCtx.createOscillator();
    const g = audioCtx.createGain();
    o.type = type; o.frequency.setValueAtTime(freq, audioCtx.currentTime);
    g.gain.setValueAtTime(vol, audioCtx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + dur);
    o.connect(g); g.connect(audioCtx.destination);
    o.start(); o.stop(audioCtx.currentTime + dur);
  } catch (err) { logger.debug("audio op failed", err); }
};

export const playMoveSound = () => playTone(600, 0.05, 'sine', 0.1);
export const playCorrectSound = () => {
  playTone(523, 0.1, 'sine', 0.3);
  setTimeout(() => playTone(659, 0.1, 'sine', 0.3), 80);
  setTimeout(() => playTone(784, 0.15, 'sine', 0.3), 160);
  setTimeout(() => playTone(1047, 0.2, 'sine', 0.3), 250);
};
export const playWrongSound = () => {
  playTone(250, 0.15, 'triangle', 0.15);
  setTimeout(() => playTone(200, 0.2, 'triangle', 0.15), 120);
};
export const playLevelUpSound = () => {
  const notes = [523, 659, 784, 1047, 1319, 1568];
  notes.forEach((n, i) => setTimeout(() => playTone(n, 0.15, 'sine', 0.2), i * 80));
};
export const playStarSound = () => playTone(1200, 0.1, 'sine', 0.15);

export const speakText = (text) => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = getVoiceLang(); u.rate = 0.85; u.pitch = 1.0; u.volume = 1.0;
  window.speechSynthesis.speak(u);
};
